import { TitleContainer } from 'components/TitleContainer';
import type { ListIncome } from '../income/types';
import type { ListExpense } from '../expenses/types';
import { formatDate, sepFormat } from 'utilities';

export const numberColumnWidth = 160;

export const totalsColumn = {
  content: <TitleContainer title="Total" subtitle="Sub total" />,
  configLabel: 'Total / Sub Total',
  key: 'total',
  render: ({ total, sub_total }: ListIncome | ListExpense) => (
    <TitleContainer title={sepFormat(total)} subtitle={sepFormat(sub_total)} />
  ),
  width: 110,
  cellProps: { className: 'text-right py-0' },
  sortable: true,
} as const;

export const datesColumns = {
  key: 'checkout_date',
  configLabel: 'Checkout date',
  cellProps: { className: 'text-left py-0' },
  sortable: true,
  width: 120,
  content: <TitleContainer title="Date" subtitle="Payment date" />,
  render: ({ checkout_date, payment_date }: ListIncome | ListExpense) => (
    <TitleContainer title={formatDate(checkout_date)} subtitle={formatDate(payment_date)} />
  ),
};
